<div class="w-4 h-4 border-2 inline-block border-white rounded-full animate-spin no-border-r"></div>
